import styled from 'styled-components';

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	${({ theme }) => theme.typography.textXL};
	color: ${({ theme }) => theme.primaryBlackColor};
	margin-bottom: 16px;
	column-gap: 10px;

	@media (max-width: 600px) {
		${({ theme }) => theme.typography.textBoldL};
	}
`;

export const ServicesTitle = styled.div``;

export const ServicesPrice = styled.div``;

export const ServicesSubtitle = styled.div`
	${({ theme }) => theme.typography.textM};
	color: ${({ theme }) => theme.primaryBlackColor};
	margin-bottom: 16px;

	@media (max-width: 600px) {
		${({ theme }) => theme.typography.textS};
	}
`;

export const ServicesList = styled.div`
	margin-bottom: 32px;

	@media (max-width: 600px) {
		margin-bottom: 24px;
	}
`;

export const ListItem = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	margin-bottom: 8px;

	svg {
		width: 16px;
		height: 16px;
		margin: 2px 6px 0 0;
		flex-shrink: 0;
	}

	p {
		margin: 0;
		${({ theme }) => theme.typography.textMediumS};
	}
`;

export const TopWrapper = styled.div`
	display: flex;
	flex-direction: row;
	margin: -4px;
	margin-bottom: 20px;
	${({ theme }) => theme.typography.textXS};

	& > div {
		margin: 4px;
	}
`;
export const ServicesStatus = styled.div`
	display: flex;
	align-items: center;
	padding: 5px 12px;
	background-color: ${({ theme }) => theme.primaryColor};
	color: #fff;

	margin-right: 8px;
	border-radius: 4px;
`;
